import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronLeftIcon } from '@heroicons/react/20/solid';
import { useConfirm } from './ConfirmProvider';
import { DISCARD } from './Sheet';
import { hasUnsavedChanges } from './unsavedChanges';
import './ui.css';

/**
 * Back to the parent page: "‹ Members". Goes back through history when there
 * is some, so a filtered list or scroll position comes back; opened from a
 * link, it goes to `to`. Asks first if a form on the page has unsaved changes.
 */
export default function BackLink({ to, label }) {
  const navigate = useNavigate();
  const confirm = useConfirm();
  const go = async (e) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    if (hasUnsavedChanges() && !(await confirm(DISCARD))) return;
    if (window.history.state?.idx > 0) navigate(-1);
    else navigate(to);
  };
  return (
    <Link to={to} className="ui-backlink" onClick={go}>
      <ChevronLeftIcon aria-hidden="true" />
      <span>{label}</span>
    </Link>
  );
}
